<div class="generalPage" aria-label="help-searching" role="main">
  <div class="pr-22 content-container pb-0 print-all-content" [ngClass]="IsRightPanel?'pt-0':''">
    <h1 class="generalHeader margin-0 content-blue bold itcHeavyFont pb-heading" role="heading">{{searching_heading}}</h1>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="searching_desc"></p>
    <p class="answer font-24 content-blue width-100 mb-invert-12 bold pb-heading" role="heading">{{searching_para1heading}}</p>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="searching_para1body"></p>
    <p class="answer font-24 content-blue width-100 mb-invert-12 bold pb-heading" role="heading">{{searching_para2heading}}</p>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="searching_para2body"></p>
  </div>
</div>
